package app.nestbridge.feature.messages.ui

import app.nestbridge.feature.messages.screen.MessagesScreen
import app.nestbridge.feature.messages.screen.MessagesState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class MessagesUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    MessagesScreen -> ui<MessagesState> { state, modifier -> MessagesUi(state = state, modifier = modifier) }
    else -> null
  }
}
